import { useTranslation } from "react-i18next";
import { PLACEHOLDER_IMAGES } from "../../utility/placeholders";
import "./MarketplaceProductCard.scss";

const MarketplaceProductCard = ({ product, providerName, isSelected = false, onClick }) => {
  const { t } = useTranslation("marketplace");
  const hasQuantity = product.quantity !== false;

  return (
    <button className="marketplace-product-card" onClick={onClick} type="button">
      <div className="marketplace-product-card__image">
        <img
          src={product.imageUrl}
          alt={product.name}
          draggable={false}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = PLACEHOLDER_IMAGES.PRODUCT;
          }}
        />
        {isSelected && (
          <span className="marketplace-product-card__selected">
            {t("provider.selected", { defaultValue: "Ajouté" })}
          </span>
        )}
      </div>

      <div className="marketplace-product-card__content">
        {providerName && <span className="marketplace-product-card__provider">{providerName}</span>}
        <h3>{product.name}</h3>
        <p>{product.description}</p>
        <div className="marketplace-product-card__footer">
          <span>
            {hasQuantity
              ? t("provider.quantity_available", { defaultValue: "Quantité au choix" })
              : t("provider.on_request", { defaultValue: "Sur demande" })}
          </span>
          <strong>{t("provider.add_short", { defaultValue: "Ajouter" })}</strong>
        </div>
      </div>
    </button>
  );
};

export default MarketplaceProductCard;
